// Production uses the same origin and lets the frontend reverse proxy route /api.
export const API_URL = process.env.REACT_APP_API_URL || ""
